module.exports = __webpack_public_path__ + "img/fury.af6283e5.jpg";